import React from 'react';

interface ProductNameColumnProps {
  transaction: any;
  location?: string;
  viewType?: string;
  handleEdit?: (transaction: any) => void;
}

const FormatHierarchyType = ({ transaction }: { transaction: any }) => {
  if (transaction?.hierarchy_type === 'Assembly') {
    return (
      <div className='product-row-column'>
        <div className='Assembly'>ASM</div>
      </div>
    );
  } else if (transaction?.hierarchy_type === 'Sub-Assembly') {
    return (
      <div className='product-row-column'>
        <div className='Sub-Assembly'>SUB</div>
      </div>
    );
  } else if (transaction?.hierarchy_type === 'Component') {
    return (
      <div className='product-row-column'>
        <div className='Component'>BOM</div>
      </div>
    );
  }
  return <></>;
};

const FormattedName: React.FC<ProductNameColumnProps> = ({
  transaction,
  handleEdit,
}) => {
  return (
    <div
      className='product-name-row-item'
      onClick={
        typeof handleEdit === 'function'
          ? () => handleEdit(transaction)
          : undefined
      }
    >
      <FormatHierarchyType transaction={transaction} />
      <div className='product-row-column'>
        <span className='screening-results-row-link-cell-text product-row-rows'>
          <b>{transaction?.name}</b>
        </span>
      </div>
    </div>
  );
};
export default FormattedName;
